import React, { useRef } from 'react';
import { Plus, X } from 'lucide-react';
import { MAX_TRAVEL_IMAGES } from '../../utils/travelImages';
import { useModal } from '../../context/ModalContext';

// Shared photo picker for travel post create/edit forms.
// items: [{ url: string (preview objectURL or existing public URL), file?: File }]
// The first image is used as the list-card cover.
export default function TravelImagePicker({ items, onChange }) {
  const inputRef = useRef(null);
  const { showAlert } = useModal();

  const handlePick = (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = '';
    if (files.length === 0) return;

    const room = MAX_TRAVEL_IMAGES - items.length;
    if (files.length > room) {
      showAlert('提示', `最多只能放 ${MAX_TRAVEL_IMAGES} 張照片`);
    }
    const accepted = [];
    for (const file of files.slice(0, Math.max(room, 0))) {
      if (!file.type.startsWith('image/')) {
        showAlert('提示', '僅支援圖片檔案');
        continue;
      }
      if (file.size > 10 * 1024 * 1024) {
        showAlert('提示', '單張圖片不能超過 10MB');
        continue;
      }
      accepted.push({ file, url: URL.createObjectURL(file) });
    }
    if (accepted.length > 0) onChange([...items, ...accepted]);
  };

  const handleRemove = (index) => {
    const removed = items[index];
    if (removed.file) URL.revokeObjectURL(removed.url);
    onChange(items.filter((_, i) => i !== index));
  };

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        {items.map((item, index) => (
          <div key={item.url} style={{ position: 'relative', width: '84px', height: '84px' }}>
            <img
              src={item.url}
              alt={`旅程照片 ${index + 1}`}
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '12px', border: '1px solid #e5e7eb' }}
            />
            {index === 0 && (
              <span style={{
                position: 'absolute', bottom: '4px', left: '4px',
                background: 'rgba(0,0,0,0.55)', color: 'white',
                fontSize: '10px', fontWeight: '600', padding: '2px 6px', borderRadius: '6px'
              }}>
                封面
              </span>
            )}
            <button
              type="button"
              onClick={() => handleRemove(index)}
              style={{
                position: 'absolute', top: '-6px', right: '-6px',
                width: '22px', height: '22px', borderRadius: '50%',
                background: '#ef4444', color: 'white', border: '2px solid white',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', padding: 0
              }}
            >
              <X size={12} strokeWidth={3} />
            </button>
          </div>
        ))}

        {items.length < MAX_TRAVEL_IMAGES && (
          <button
            type="button"
            onClick={() => inputRef.current && inputRef.current.click()}
            style={{
              width: '84px', height: '84px', borderRadius: '12px',
              border: '2px dashed #9cc2e6', background: '#f8fafc',
              color: '#4e8bca', cursor: 'pointer',
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '4px'
            }}
          >
            <Plus size={20} />
            <span style={{ fontSize: '11px', fontWeight: '600' }}>{items.length}/{MAX_TRAVEL_IMAGES}</span>
          </button>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        onChange={handlePick}
        style={{ display: 'none' }}
      />
    </div>
  );
}
